/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './dispute_ledger_common';
import '../../common/currency';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "AdjustDisputedAmountRequest": {
                "fields": {
                  "context": {
                    "type": ".squareup.corporate_card.service.RequestContext",
                    "id": 1,
                    "rule": "optional"
                  },
                  "transactionToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "adjustmentMoney": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "reference": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "AdjustDisputedAmountResponse": {
                "fields": {
                  "result": {
                    "type": ".squareup.corporate_card.service.TransactionResult",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errorMessage": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "ledgerEntryToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 4,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.AdjustDisputedAmountRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.AdjustDisputedAmountResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE AdjustDisputedAmountRequest @ squareup/corporate_card/service/adjust_disputed_amount.proto at 11:1
 */
export const AdjustDisputedAmountRequest = $root.lookupType('squareup.corporate_card.service.AdjustDisputedAmountRequest');
fixType(AdjustDisputedAmountRequest, {
  context: {
    notEmpty: true
  },
  transactionToken: {
    notEmpty: true
  },
  adjustmentMoney: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(AdjustDisputedAmountRequest);
/**
 * SOURCE AdjustDisputedAmountResponse @ squareup/corporate_card/service/adjust_disputed_amount.proto at 33:1
 */
export const AdjustDisputedAmountResponse = $root.lookupType('squareup.corporate_card.service.AdjustDisputedAmountResponse');
fixType(AdjustDisputedAmountResponse, {
  result: {
    required: true
  }
});
Builder.createAndAttachToType(AdjustDisputedAmountResponse);